import swan from "./swanservice";

class TryonService {
	tryonSubmit(params) {
		return swan.tryOn.handleTryOnSubmit({ ...params,requestSource
			: 
			"opentryon"});
	}

	handleTryOnWebSocket(params) {
		try {
			swan.tryOn.handleTryOnWebSocket({
				tryonId: params?.tryonId,
				onSuccess: params?.onSuccess,
				onError: (e) => {
					params?.onError?.(e)
					// if (e?.target?.readyState !== WebSocket.CLOSING && e?.target?.readyState !== WebSocket.CLOSED) {
					// 	params?.onError?.(e, ERROR_TYPE.TRY_ON);
					// }else{
					// 	postHogEvent({ type: "websocket close event from browser", status: "websocket closed", openTryonId: params?.tryonId }, "/browser-websocket-close");
					// }
				},
			});
		} catch (error) {
			console.log(error, "while connecting websocket");
		}
	}
}

const tryOnService = new TryonService()

export default tryOnService